import { render, staticRenderFns } from "./header-cart-button.vue?vue&type=template&id=93d80e72&scoped=true"
import script from "./header-cart-button.vue?vue&type=script&lang=js"
export * from "./header-cart-button.vue?vue&type=script&lang=js"
import style0 from "./header-cart-button.vue?vue&type=style&index=0&id=93d80e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d80e72",
  null
  
)

export default component.exports